import { createContext } from 'react';
import { RootStore } from '../store';

// todo: use real default value insteadof empty object when remove typedi
export const StoresContext = createContext<RootStore>({} as RootStore);
